module.exports = __webpack_public_path__ + "static/media/Milk_lite1.4bb85396.jpg";